import { cloneDeep, filter, find, findKey, forEach, isEmpty, map, uniq } from 'lodash';
import moment from 'moment';

class CustomiseController {

    constructor($scope, basket, checkout, availabilityApiService, markdownService, checkoutValidationService, guestnameService) {
        this.$scope = $scope;
        this.basket = basket;
        this.checkout = checkout;
        this.availabilityApiService = availabilityApiService;
        this.markdownService = markdownService;
        this.checkoutValidationService = checkoutValidationService;
        this.nameService = guestnameService;
    }

    $onInit () {
        //For Alexander's purposes...
        this.autoExpand = true;

        this.spadays = {};
        this.availability = {};
        this.display = [];
        this.displayDropdown = null;
        this.unavailableDays = [];

        this.hasError = false;
        this.loading = true;
        this.basket.saving = true;
        this.dates = [];

        return this.basket.promise.then(() => {
            this.dates = this.basketDates();

            if (this.dates.length) {
                for (var key in this.dates) {
                    this.dates[key] = moment(this.dates[key]).format('YYYY-MM-DD');
                };
                this.dates = uniq(this.dates);

                return this.requestCreditListForDates()
                    .then(() => {
                        this.populateSpaDays();
                    })
                    .catch(() => {
                        this.hasError = true;
                    })
                    .then(() => {
                        this.checkout.setStepByName('credit');
                        this.stopLoading();
                        // In order to update the basket.saving
                        // value in other components, we need to
                        // force $rootScope to recheck everything...
                        this.$scope.$apply();
                    });
            }

            this.stopLoading();
        });
    }

    requestCreditListForDates () {
        let dateRequests = this.dates.map(date => {
            return this.availabilityApiService.requestCreditAvailabilityList(date)
                .then(response => {
                    this.availability[date] = response;
                });
        });

        return Promise.all(dateRequests);
    }

    stopLoading () {
        this.loading = false;
        this.basket.saving = false;
    }

    guestHasDays (guest) {
        if (guest.spaday > 0) {
            let days = filter(guest.item_details, { item_type: 'App\\SpaDay' });
            if (days) {
                for (let day of days) {
                    if (this.hasDayReference(day.reference)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    hasDayReference (reference) {
        return Object.keys(this.spadays).indexOf(reference) > -1;
    }

    findDay (reference) {
        return find(this.spadays, { 'reference': reference });
    }

    findDayTreatments (reference) {
        let day = find(this.spadays, { 'reference': reference });
        if (day) {
            return day.treatments;
        }
    }

    addEvent (reference, treatment, guests) {
        if (guests || guests === 'all') {
            let original_guests = null;

            if (guests === 'all') {
                original_guests = 'all';
                guests = map(this.referenceGuests(reference), 'id');
            }

            for (let guestId of guests) {
                let guest = find(this.basket.contents.guest_details, { id: parseInt(guestId) });
                if (guest) {
                    let day = find(guest.item_details, { reference: reference });
                    if (day) {
                        let existingTreatment = this.hasEvent(day, treatment.id, false);
                        if (existingTreatment) {
                            if (original_guests !== 'all') {
                                if (day.item_children) {
                                    day.item_children.splice(existingTreatment, 1);
                                }
                                if (day.credit_state) {
                                    day.credit_state.splice(existingTreatment, 1);
                                }
                                if (this.spadays[reference].selected[treatment.id]) {
                                    this.spadays[reference].selected[treatment.id][guest.id] = false;
                                }
                            }
                        } else {
                            treatment.type = 'Treatment';
                            treatment.date = day.date;
                            if (day.item_children) {
                                day.item_children.push(this.basket.assignItem(treatment, this.basket.referenceGenerator()));
                            }
                            if (!this.spadays[reference].selected) {
                                this.spadays[reference].selected = [];
                            }
                            if (!this.spadays[reference].selected[treatment.id]) {
                                this.spadays[reference].selected[treatment.id] = [];
                            }
                            this.spadays[reference].selected[treatment.id][guest.id] = true;
                        }
                    }
                }
            }
            this.displayDropdown = null;
            this.basket.submit('delete_orders');
        }
    }

    addEventSelected (reference, treatment, guests) {
        if (guests && Object.keys(guests).length > 0) {
            for (let guest of this.basket.contents.guest_details) {
                let day = find(guest.item_details, { reference: reference });
                if (day) {
                    let existingTreatment = this.hasEvent(day, treatment.id, false);
                    let treatmentSelection = guests[treatment.id];

                    if (treatmentSelection[guest.id] && treatmentSelection[guest.id] === true) {
                        if (!existingTreatment) {
                            treatment.type = 'Treatment';
                            treatment.date = day.date;
                            day.item_children.push(this.basket.assignItem(treatment));
                        }
                    } else {
                        if (existingTreatment !== undefined) {
                            day.item_children.splice(existingTreatment, 1);
                        }
                    }
                }
            }
            this.displayDropdown = null;
            this.basket.submit('delete_orders');
        }
    }

    hasEvent (guestDay, treatmentId, boolean = true) {
        let existing = findKey(guestDay.item_children, { item_type: 'App\\Treatment', item_id: treatmentId });
        if (boolean) {
            return existing > -1;
        }
        return existing;
    }

    guestHasEvent (guestId, guestDay, treatmentId) {
        let guest = find(this.basket.contents.guest_details, { 'id': guestId });
        if (guest) {
            let ref = guestDay.reference;
            let guestGuestDay = find(guest.item_details, { 'reference': ref });
            if (guestGuestDay) {
                return this.hasEvent(guestGuestDay, treatmentId);
            }
        }
        return false;
    }

    switchVisible (guestId, dayId, treatmentId = null, single = null) {
        let id = `${guestId}-${dayId}`;
        if (treatmentId) {
            id += `-${treatmentId}`;
        }
        if (single) {
            let existing = this.displayDropdown === id;
            if (existing) {
                this.displayDropdown = null;
            } else {
                this.displayDropdown = id;
            }
        } else {
            let existing = this.display.indexOf(id);
            if (existing > -1) {
                if (this.display.length === 1) {
                    this.display = [];
                } else {
                    this.display.splice(existing, 1);
                }
            } else {
                this.display.push(id);
            }
        }
    }

    isDisplayed (guestId, dayId, treatmentId = null, single = null) {
        // Error override
        if (this.checkout.spadayError && this.checkout.spadayError.indexOf(dayId) > -1 && !treatmentId) {
            return true;
        }

        let id = `${guestId}-${dayId}`;
        if (treatmentId) {
            id += `-${treatmentId}`;
        }
        if (single) {
            return this.displayDropdown === id;
        } else {
            return this.display.indexOf(id) > -1;
        }
    }

    isDisplayedError (dayId) {
        if (this.checkout.spadayError && this.checkout.spadayError.indexOf(dayId) > -1) {
            return true;
        }
        return false;
    }

    referenceGuests (reference) {
        let guests = [];

        for (let guest of this.basket.contents.guest_details) {
            if (find(guest.item_details, { 'reference': reference })) {
                guests.push(guest);
            }
        }
        return guests;
    }

    treatmentsSelected (day) {
        let found = filter(day.item_children, { item_type: 'App\\Treatment' });
        if (found) {
            return found.length;
        }
        return 0;
    }

    noSpaDays () {
        if (!this.loading && Object.keys(this.spadays).length === 0) {
            return true;
        }
        return false;
    }

    populateSpaDays () {
        for (let guest of this.basket.contents.guest_details) {
            for (let guestDay of filter(guest.item_details, { 'item_type': 'App\\SpaDay' })) {
                if (this.autoExpand) {
                    this.switchVisible(guest.id, guestDay.id);
                }

                this.addDayAndTreatments(guestDay);

                this.reassignSelectedTreatments(guestDay, guest.id);
            }
        }
        this.updateValidation();
    }

    addDayAndTreatments (guestDay) {
        if (guestDay.item.treatments && guestDay.item.treatments.length && !this.spadays[guestDay.reference]) {
            this.buildDayByReference(guestDay);

            this.addCreditTreatmentsIfAvailable(guestDay);

            this.removeEmptyCategoriesAndDaysByReference(guestDay.reference);
        }
    }

    buildDayByReference (guestDay) {
        this.spadays[guestDay.reference] = cloneDeep(guestDay);
        this.spadays[guestDay.reference].treatments = {};
        this.spadays[guestDay.reference].selected = [];
    }

    addCreditTreatmentsIfAvailable (guestDay) {
        for (let treatment of this.availability[moment(guestDay.date).format('YYYY-MM-DD')]) {
            this.addSpaDayCategoryName(guestDay.reference, treatment.category_name);

            if (find(guestDay.item.treatments, { id: parseInt(treatment.id) }) &&
                treatment.availability.available === true) {
                this.spadays[guestDay.reference].treatments[treatment.category_name].push(treatment);
            }
        }
    }

    addSpaDayCategoryName (reference, categoryName) {
        if (!this.spadays[reference].treatments[categoryName]) {
            this.spadays[reference].treatments[categoryName] = [];
        }
    }

    removeEmptyCategoriesAndDaysByReference (reference) {
        forEach(this.spadays[reference].treatments, (value, key) => {
            if (!value.length) {
                delete this.spadays[reference].treatments[key];
            }
        });

        if (isEmpty(this.spadays[reference].treatments)) {
            this.unavailableDays.push({ id: this.spadays[reference].id });
            delete this.spadays[reference];
        }
    }

    reassignSelectedTreatments (guestDay, guestId) {
        if (this.spadays[guestDay.reference]) {

            for (let child of guestDay.item_children) {
                if (!this.spadays[guestDay.reference].selected[child.item_summary.id]) {
                    this.spadays[guestDay.reference].selected[child.item_summary.id] = [];
                }
                this.spadays[guestDay.reference].selected[child.item_summary.id][guestId] = true;
            }
        }
    }

    updateValidation () {
        this.checkoutValidationService.additionalRequirements(this.unavailableDays);
    }

    presentGuestName (guest) {
        return this.nameService.format(guest, true, 'Spa Day', guest.spaday);
    }

    presentDate (date) {
        return moment(date).format('Do MMMM, YYYY');
    }

    sumCredit (children) {
        let total = 0;
        if (children.length) {
            children.forEach(child => {
                if (child.item_type === 'App\\Treatment') {
                    total += child.credit_value;
                }
            });
        }
        return total;
    }

    basketDates () {
        let dates = [];

        if (!this.basket.contents
            || !this.basket.contents.guest_details
            || this.basket.contents.guest_details.length === 0) {
            return dates;
        }

        this.basket.contents.guest_details.forEach(guest => {
            guest.item_details.forEach(item => {
                if (item.item_type === 'App\\SpaDay'
                    && item.item
                    && (item.item.treatments
                        && Object.keys(item.item.treatments).length > 0)
                    && moment(item.date).isValid()) {
                    dates.push(item.date);
                }
            });
        });

        return dates;
    }
}

CustomiseController.$inject = ['$scope', 'basket', 'checkout', 'availabilityApiService', 'markdownService', 'checkoutValidationService', 'guestnameService'];

export default CustomiseController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/controllers/customise.controller.js